import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { FlightSortOptions } from 'constants/flight'

function useFlightSortOptions() {
  const intl = useIntl()

  return useMemo(() => ([
    {
      value: FlightSortOptions.Cheapest,
      label: intl.formatMessage({
        id: '33LOApeo-RdCT8p-0fyo',
        defaultMessage: 'Cheapest',
        description: 'Flight sort option label for cheapest price in the flights flow',
      }),
      tooltip: intl.formatMessage({
        id: 'GFakQIJ51xOhQtNf2ws8',
        defaultMessage: 'Sort flights by cheapest price.',
        description: 'Tooltip for flight cheapest sort option in the flight search or booking flow',
      }),
    },
    {
      value: FlightSortOptions.Best,
      label: intl.formatMessage({
        id: 'q2oNwawP4Bj3cplKWgUM',
        defaultMessage: 'Best',
        description: 'Flight sort option label for best overall value in the flights section',
      }),
      tooltip: intl.formatMessage({
        id: 'RZbFYzUQz_4ZxnepTIjh',
        defaultMessage: 'Sort flights based on number of stopovers, price and flight duration.',
        description: 'Tooltip for flight best sort option in the flight search or booking flow',
      }),
    },
    {
      value: FlightSortOptions.Fastest,
      label: intl.formatMessage({
        id: 'ciejnB5c9M6-DGuQ0i_1',
        defaultMessage: 'Fastest',
        description: 'Flight sort option label for fastest flight time in the flights section',
      }),
      tooltip: intl.formatMessage({
        id: 'TR0KlPm4jqdJHhxnFG8_',
        defaultMessage: 'Sort flights by fastest flight time.',
        description: 'Tooltip for flight fastest sort option in the flight search or booking flow',
      }),
    },
  ]), [intl])
}

export default useFlightSortOptions
